import { analytics } from "../firebase/firebase";
import { logEvent } from "firebase/analytics";

export const trackEvent = (eventName, params = {}) => {
  try {
    logEvent(analytics, eventName, params);
  } catch (error) {
    console.error("Failed to log analytics event:", error);
  }
};

export const trackPageView = (page_path) => {
  try {
    logEvent(analytics, 'page_view', { page_path });
  } catch (error) {
    console.error("Failed to log page view:", error);
  }
};


export const trackSessionStart = () => {
  try {
    logEvent(analytics, 'session_start', {
      timestamp: Date.now()
    });
  } catch (error) {
    console.error("Failed to log session start:", error);
  }
};

export const trackSessionEnd = () => {
  try {
    logEvent(analytics, 'session_end', {
      timestamp: Date.now()
    });
  } catch (error) {
    console.error("Failed to log session end:", error);
  }
};
